import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtEuroCents } from "@/lib/format";
import { X } from "lucide-react";

const nf = new Intl.NumberFormat("el-GR", { maximumFractionDigits: 0 });

export const PivotDrillModal = ({ drill, onClose }) => {
  const { data, isLoading } = useQuery({ queryKey: ["erp-pivot-docs", drill], queryFn: async () => (await api.get("/erp/pivot/docs", { params: drill.params })).data });
  const rows = data?.rows || [];
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 overflow-y-auto" data-testid="pv-drill-modal" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-5xl mt-8 border border-[#E3DED4]" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-[#E3DED4] flex items-start justify-between gap-3">
          <div>
            <h3 className="font-medium text-[#45423C]">Παραστατικά κελιού</h3>
            <p className="text-xs text-[#6F6A60] mt-0.5">{drill.title}</p>
          </div>
          <div className="text-right text-xs text-[#6F6A60]">
            {data && <><div><strong className="text-[#45423C] tabular">{data.count}</strong> γραμμές</div><div>Ποσ. <strong className="tabular">{nf.format(data.qty)}</strong> · Αξία <strong className="tabular text-[#45423C]">{fmtEuroCents(data.net)}</strong></div></>}
          </div>
          <button data-testid="pv-drill-close" onClick={onClose} className="p-1.5 rounded-lg hover:bg-[#F1EDE6]"><X className="h-4 w-4" /></button>
        </div>
        <div className="max-h-[70vh] overflow-auto">
          <table className="w-full text-xs">
            <thead className="bg-[#F3F0EA] text-[10px] uppercase tracking-wider text-[#6F6A60] sticky top-0">
              <tr><th className="px-3 py-2 text-left">Ημ/νία</th><th className="px-3 py-2 text-left">Προμηθευτής</th><th className="px-3 py-2 text-left">Είδος</th><th className="px-3 py-2 text-left">Κατηγορίες</th><th className="px-3 py-2 text-right">Ποσ.</th><th className="px-3 py-2 text-right">Αξία</th><th className="px-3 py-2 text-right">Τιμή/μον.</th></tr>
            </thead>
            <tbody>
              {isLoading && <tr><td colSpan={7} className="px-4 py-6 text-center text-[#6F6A60]">Φόρτωση…</td></tr>}
              {rows.map((r, i) => (
                <tr key={i} className="border-t border-[#F1EDE6] hover:bg-[#FAF8F4]" data-testid={`pv-drill-row-${i}`}>
                  <td className="px-3 py-1.5 whitespace-nowrap">{new Date(r.date).toLocaleDateString("el-GR")}</td>
                  <td className="px-3 max-w-[200px] truncate" title={r.supplier}>{r.supplier}</td>
                  <td className="px-3 max-w-[280px] truncate" title={r.item}>{r.item}</td>
                  <td className="px-3 text-[#8A8577] max-w-[220px] truncate">{[r.cat1, r.cat2, r.cat3].filter(Boolean).join(" › ")}</td>
                  <td className="px-3 text-right tabular">{nf.format(r.qty)}</td>
                  <td className={`px-3 text-right tabular ${r.net < 0 ? "text-[#6E7A63]" : ""}`}>{fmtEuroCents(r.net)}</td>
                  <td className="px-3 text-right tabular text-[#6F6A60]">{r.qty ? fmtEuroCents(r.net / r.qty) : "—"}</td>
                </tr>
              ))}
              {!isLoading && rows.length === 0 && <tr><td colSpan={7} className="px-4 py-6 text-center text-[#6F6A60]">Καμία γραμμή.</td></tr>}
            </tbody>
          </table>
          {data?.count >= 2000 && <p className="px-4 py-2 text-xs text-[#6F6A60]">Εμφανίζονται οι πρώτες 2.000 γραμμές.</p>}
        </div>
      </div>
    </div>
  );
};
